import { useMutation } from '@tanstack/react-query';
import { useCurrentUser, userDomain } from '@user';

export const useUpdatePassword = () => {
  const { id } = useCurrentUser();
  return useMutation((payload: userDomain.UpdatePasswordDto) => {
    return userDomain.userRepository.updatePassword(id, payload);
  });
};
